import { ActiveSection } from './types';

export const STATUS_OPTIONS = [
  { value: 'PUBLISHED', label: 'Published' },
  { value: 'DRAFT',     label: 'Draft'     },
  { value: 'UNPUBLISH', label: 'Unpublish' },
];

export const SECTION_HUMAN: Record<ActiveSection, string> = {
  heroSection:           'Hero',
  joinusSection:         'Join Us',
  contactSection:        'Contact',
  ourValueSection:       'Our Value',
  ourmissionSection:     'Our Mission',
  differentiatorSection: 'Differentiator',
};

export const SECTION_HEADING: Record<ActiveSection, string> = {
  heroSection:           'Company-Hero sector',
  joinusSection:         'Company-Join Us section',
  contactSection:        'Company-Contact section',
  ourValueSection:       'Company-Our Value section',
  ourmissionSection:     'Company-Our Mission section',
  differentiatorSection: 'Company-Differentiator section',
};

export const SECTION_KEY: Record<ActiveSection, string> = {
  heroSection:           'CP-001',
  joinusSection:         'CP-002',
  contactSection:        'CP-003',
  ourValueSection:       'CP-004',
  ourmissionSection:     'CP-005',
  differentiatorSection: 'CP-006',
};